'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * SkipLink component, used to display a skip link within the page.
 * Place it at the top of the page to allow users to skip to the main content.
 *
 * @example
 * <SkipLink href='#main-content'>Skip to main content</SkipLink>
 */
const SkipLink = forwardRef(function SkipLink({ children, className, ...rest }, ref) {
    return (jsx("a", { className: cl('ds-skip-link', className), ...rest, ref: ref, children: children }));
});

export { SkipLink };
